/******************************************************************************
 * GENERATED by scripts/generateHooks.ts — DO NOT EDIT.
 * Re-run with `pnpm zen3:generate`.
 ******************************************************************************/

/* eslint-disable */

import { useModelQueries, type ModelQueryHooks } from '@zenstackhq/tanstack-query/react';
import { schema } from '../zen3/schema-lite';

type Hooks = ModelQueryHooks<typeof schema, 'AiModel'>;
const hooks = useModelQueries(schema, 'AiModel');

export const useAggregateAiModel: Hooks['useAggregate'] = hooks.useAggregate;
export const useCountAiModel: Hooks['useCount'] = hooks.useCount;
export const useCreateAiModel: Hooks['useCreate'] = hooks.useCreate;
export const useCreateManyAiModel: Hooks['useCreateMany'] = hooks.useCreateMany;
export const useCreateManyAndReturnAiModel: Hooks['useCreateManyAndReturn'] = hooks.useCreateManyAndReturn;
export const useDeleteAiModel: Hooks['useDelete'] = hooks.useDelete;
export const useDeleteManyAiModel: Hooks['useDeleteMany'] = hooks.useDeleteMany;
export const useExistsAiModel: Hooks['useExists'] = hooks.useExists;
export const useFindFirstAiModel: Hooks['useFindFirst'] = hooks.useFindFirst;
export const useFindManyAiModel: Hooks['useFindMany'] = hooks.useFindMany;
export const useFindUniqueAiModel: Hooks['useFindUnique'] = hooks.useFindUnique;
export const useGroupByAiModel: Hooks['useGroupBy'] = hooks.useGroupBy;
export const useInfiniteFindManyAiModel: Hooks['useInfiniteFindMany'] = hooks.useInfiniteFindMany;
export const useSuspenseAggregateAiModel: Hooks['useSuspenseAggregate'] = hooks.useSuspenseAggregate;
export const useSuspenseCountAiModel: Hooks['useSuspenseCount'] = hooks.useSuspenseCount;
export const useSuspenseFindFirstAiModel: Hooks['useSuspenseFindFirst'] = hooks.useSuspenseFindFirst;
export const useSuspenseFindManyAiModel: Hooks['useSuspenseFindMany'] = hooks.useSuspenseFindMany;
export const useSuspenseFindUniqueAiModel: Hooks['useSuspenseFindUnique'] = hooks.useSuspenseFindUnique;
export const useSuspenseGroupByAiModel: Hooks['useSuspenseGroupBy'] = hooks.useSuspenseGroupBy;
export const useSuspenseInfiniteFindManyAiModel: Hooks['useSuspenseInfiniteFindMany'] = hooks.useSuspenseInfiniteFindMany;
export const useUpdateAiModel: Hooks['useUpdate'] = hooks.useUpdate;
export const useUpdateManyAiModel: Hooks['useUpdateMany'] = hooks.useUpdateMany;
export const useUpdateManyAndReturnAiModel: Hooks['useUpdateManyAndReturn'] = hooks.useUpdateManyAndReturn;
export const useUpsertAiModel: Hooks['useUpsert'] = hooks.useUpsert;
